// ULID-style time-ordered id generator — P1.17. Outside engine (uses time).

const ENCODE = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'; // Crockford base32

function encodeTime(now: number, len = 10): string {
  let ts = now;
  let out = '';
  for (let i = len - 1; i >= 0; i--) {
    const mod = ts % 32;
    out = ENCODE[mod] + out;
    ts = Math.floor(ts / 32);
  }
  return out;
}

function encodeRandom(len = 16): string {
  let out = '';
  for (let i = 0; i < len; i++) {
    out += ENCODE[Math.floor(Math.random() * 32)];
  }
  return out;
}

/** Time-ordered ULID-style id. Used in the store only (engine is deterministic). */
export function ulid(now: number = Date.now()): string {
  return encodeTime(now) + encodeRandom();
}

export function newEntityId(): string {
  return `ent_${ulid()}`;
}
